import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { caseStudies, CaseStudy } from '../data/caseStudiesData';
import './CaseStudyDetailPage.css';
import { Helmet } from 'react-helmet-async'; // Import Helmet

const CaseStudyDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const study = caseStudies.find(cs => cs.id === id);

  if (!study) {
    return (
      <div className="case-study-detail-page container">
        <Helmet>
          <title>Case Study Not Found | IntelPro</title>
          <meta name="description" content="Sorry, we couldn't find the case study you were looking for." />
        </Helmet>
        <h1>Case Study Not Found</h1>
        <p>Sorry, we couldn't find the case study you were looking for.</p>
        <Link to="/case-studies" className="btn btn-primary">Back to Case Studies</Link>
      </div>
    );
  }

  // Construct the fallback PNG URL assuming consistent naming
  const fallbackImageUrl = study.imageUrl.replace('.webp', '.png');

  return (
    <div className="case-study-detail-page container">
      <Helmet>
        <title>{study.title} | IntelPro</title>
        <meta name="description" content={`Learn more about our case study: ${study.title}`} />
      </Helmet>
      {/* Use <picture> element */}
      <picture>
        <source srcSet={study.imageUrl} type="image/webp" />
        <img
          src={fallbackImageUrl} // Use PNG as fallback src
          alt={study.title}
          className="case-study-image"
          // No lazy loading here - likely above the fold
        />
      </picture>

      <h1>{study.title}</h1>
      <div className="case-study-meta">
        <span><strong>Client Type:</strong> {study.clientType}</span>
        <span><strong>Duration:</strong> {study.duration}</span>
      </div>

      <section className="case-study-section">
        <h2>Situation</h2>
        <p>{study.situation}</p>
      </section>

      <section className="case-study-section">
        <h2>Our Approach</h2>
        <p>{study.approach}</p>
      </section>

      <section className="case-study-section">
        <h2>Results</h2>
        <ul>
          {study.results.map((result, index) => (
            <li key={index}>{result}</li>
          ))}
        </ul>
      </section>

      <div className="back-link-container">
        <Link to="/case-studies" className="btn-outline-secondary"> {/* Use the primary outline style */}
          Back to All Case Studies
        </Link>
      </div>
    </div>
  );
};

export default CaseStudyDetailPage;